/**
 * Referrer Control Component
 * 
 * Controls display based on referrer URL
 * 
 * @package TopBuddy
 */

import { ToggleControl, TextControl } from '@wordpress/components';
import { __ } from '@wordpress/i18n';
import ProBadge from '../ProBadge';

const ReferrerControl = ({ enabled, url, onEnabledChange, onUrlChange }) => {
	const postSettingsData = window.topbuddyPostSettings || {};
	const isProActive = postSettingsData.isProActive || false;
	const upgradeUrl = postSettingsData.upgradeUrl || 'https://wptopbuddy.com/?utm_source=plugin&utm_medium=topbuddy-free-plugin&utm_campaign=topbuddy-free-plugin-admin';

	return (
		<div className="topbuddy-display-rules__field">
			<ToggleControl
				label={
					<>
						{__('Referrer URL', 'topbuddy')}
						{!isProActive && <ProBadge upgradeUrl={upgradeUrl} />}
					</>
				}
				help={__('Show notification only when visitor comes from this referrer URL or domain', 'topbuddy')}
				checked={enabled}
				onChange={onEnabledChange}
				disabled={!isProActive}
				__nextHasNoMarginBottom
			/>
			
			{enabled && isProActive && (
				<TextControl
					placeholder={__('e.g., google.com, facebook.com, example.com/page', 'topbuddy')}
					value={url}
					onChange={onUrlChange}
					help={__('Enter the referrer URL or domain to match (contains). Leave empty to match direct traffic.', 'topbuddy')}
					__next40pxDefaultSize
					__nextHasNoMarginBottom
				/>
			)}
		</div>
	);
};

export default ReferrerControl;
